import { Button, Result } from 'antd';

import React from 'react';

export default function UnauthorizedPage() {
  return (
    <Result
      title="Unauthorized"
      subTitle={`You are not authorized to access this page!`}
      extra={
        <Button type="primary" href="/">
          Back Home
        </Button>
      }
    />
  );
}
